import React, { useEffect, ReactElement } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Language, useLanguage } from '@/context/LanguageContext';

interface MultilingualPageWrapperProps {
  children: ReactElement;
}

const SUPPORTED_LANGUAGES: Language[] = [
  'en', 'es', 'fr', 'de', 'it', 'pt',
  'da', 'no', 'fi', 'sv', 'is',
  'cs', 'sk', 'sl', 'pl',
  'et', 'lv', 'lt',
  'el', 'nl',
  'ko', 'ja', 'zh',
  'ar', 'hi', 'ru', 'tr', 'id',
  'ro', 'bg', 'hr', 'hu', 'uk', 'he',
  'th', 'vi', 'ms', 'tl', 'fa', 'bn', 'ur', 'sw'
];

const MultilingualPageWrapper: React.FC<MultilingualPageWrapperProps> = ({ children }) => {
  const { lang } = useParams<{ lang: string }>();
  const { changeLanguage, language: currentLanguage } = useLanguage();
  const navigate = useNavigate();

  useEffect(() => {
    // If lang parameter exists, validate and update language
    if (lang) {
      const normalizedLang = lang.toLowerCase();
      
      // Check if language is valid
      if (SUPPORTED_LANGUAGES.includes(normalizedLang as Language)) {
        // Only change if different from current language
        if (normalizedLang !== currentLanguage) {
          changeLanguage(normalizedLang as Language);
        }
      } else {
        // Invalid language, redirect to English version
        console.warn(`Invalid language code: ${lang}. Redirecting to English.`);
        const currentPath = window.location.pathname.replace(`/${lang}`, '') || '/';
        navigate(currentPath, { replace: true });
      }
    }
  }, [lang, currentLanguage, changeLanguage, navigate]);

  return children;
};

export default MultilingualPageWrapper;
